import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { DisclaimerSection } from './components/DisclaimerSection';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Set SEO Meta Tags
    document.title = 'Protocolo Prostata: Noches en Paz | Guía Digital para Dormir Mejor';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Guía digital en PDF con protocolo de 72 horas, plan de cenas y guía 3AM para ayudarte a dormir con más calma y menos despertares nocturnos.');
    // Initialize Meta Pixel
    initMetaPixel();
    // Small delay to ensure pixel script is loaded
    const timer = setTimeout(() => {
      trackPageView();
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-navy-900 font-body selection:bg-gold-500/30 selection:text-white pb-20 md:pb-0" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StorySection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <FeaturesSection data-id="element-5" />
      <HowItWorksSection data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <DisclaimerSection data-id="element-11" />
      <Footer data-id="element-12" />
      <StickyMobileCTA data-id="element-13" />
    </div>;
}